<template>
  <span :style="counterStyles" class="items-amount-counter">
    <counter-tag>{{ amount }}</counter-tag>
    <need-review-circle v-if="isNeedReview"></need-review-circle>
  </span>
</template>

<script>
import CounterTag from '../text-blocks/CounterTag';

import NeedReviewCircle from '../badges/NeedReviewCircle';

export default {
  props: {
    amount: Number,
    isNeedReview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      letterWidth: 9,
      minSize: 16
    };
  },
  computed: {
    counterStyles() {
      let amount = this.amount !== null ? this.amount : 0;
      let counterWidth = this.letterWidth * amount.toString().length;
      let minWidth = counterWidth > this.minSize ? counterWidth + 5 : this.minSize;

      return {
        'min-width': `${minWidth}px`
      };
    }
  },
  components: {
    CounterTag,
    NeedReviewCircle
  }
};
</script>

<style lang="scss" scoped>
.items-amount-counter {
  display: inline-block;
  position: relative;

  /deep/ .counter-tag {
    width: 100%;
    line-height: normal;
  }

  /deep/ .need-review-circle {
    position: absolute;
    top: -1px;
    right: -2px;
  }
}
</style>
